import { Dashboard } from '@mui/icons-material';

const admin = {
  id: 'admin-group',
  title: 'Administration',
  type: 'group',
  children: [
    {
      id: 'admin-dashboard',
      title: 'Admin Dashboard',
      type: 'item',
      url: '/admin',
      icon: Dashboard
    }
  ]
};

export default admin;
